module.exports = __webpack_public_path__ + "fonts/包图小白体.6db277b7.ttf";